import React from 'react';
import { Card } from '../../components/ui/Card';

export default function Notifications() {
  return (
    <div className="space-y-6">
      <div>
        <h2 className="text-lg font-semibold text-gray-900">Notifications</h2>
        <p className="text-sm text-gray-500 mt-1">Configure your notification preferences and alerts</p>
      </div>

      <Card className="p-6">
        <div className="space-y-6">
          <div>
            <h3 className="text-sm font-medium text-gray-900">Coming Soon</h3>
            <p className="text-sm text-gray-500 mt-1">
              Notification settings will be available soon.
            </p>
          </div>
        </div>
      </Card>
    </div>
  );
} 